<form *ngIf="staff" [formGroup]="userRolesForm">

    <div class="form-group">
        <label for="Staff_StaffRole">{{ l("StaffRole") }}</label>
        <select (change)="onSubmit()" class="form-control" name="StaffRole" id="Staff_StaffRole"
            formControlName="staffRole">
            <option *ngFor="let staff of staffRoleArray" [value]="staff.id">
                {{ staff.displayName }}
            </option>
        </select>
    </div>

    <!-- <div class="text-right">
            <button
                type="submit"
                class="btn btn-primary blue"
                [buttonBusy]="saving"
                [busyText]="l('SavingWithThreeDot')"
            >
                <i class="fa fa-save"></i>
                <span>{{ l("Save") }}</span>
            </button>
        </div> -->
</form>

<outstandingItemsModal #outstandingItemsModal></outstandingItemsModal>
<changeUserRolesModal #changeUserRolesModal (changeRole$)="changeRole()"></changeUserRolesModal>